export default [
  {
    path: '/company-profiles',
    name: 'company-profile',
    meta: { requiresAuth: true },
    component: () => import('@/pages/company-profile/index.vue')
  },
  {
    path: '/company-profiles/create',
    name: 'company-profile-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/company-profile/create.vue')
  },
  {
    path: '/company-profiles/:id',
    name: 'company-profile-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/company-profile/edit.vue'),
    props: route => ({ editData: route.params.editData })
  }
]
